module.exports = __webpack_public_path__ + "img/SOF2021-2022annualreport.6382c383.jpg";